<h3>Add a Speech</h3>
<hr />
<form (submit)="onAddSpeech($event)">
  <div class="form-group">
    <label for="title">Title</label>
    <input
      required
      type="text"
      class="form-control"
      id="title"
      aria-describedby="title"
      placeholder="Enter Speech Title"
      [(ngModel)]="title"
      name="title"
    />
  </div>

  <div class="form-group">
    <label for="author-select">Select Author</label>
    <select
      class="form-control"
      id="author-select"
      placeholder="Please select author"
      name="author"
      [(ngModel)]="author"
    >
      <option value="" selected disabled style="color: lightgray">
        Please select author
      </option>
      <option *ngFor="let author of authors$">{{ author }}</option>
    </select>
  </div>

  <div class="form-group">
    <label for="speech">Example textarea</label>
    <textarea
      class="form-control"
      id="speech"
      rows="3"
      required
      name="content"
      [(ngModel)]="content"
    ></textarea>
  </div>

  <div class="form-group">
    <label for="dateCreated">Date</label>
    <input
      required
      type="date"
      class="form-control"
      id="dateCreated"
      aria-describedby="dateCreated"
      required
      [(ngModel)]="dateCreated"
      name="dateCreated"
    />
  </div>

  <button type="submit" class="btn btn-primary">Add Speech</button>
</form>
